<template>
    <div class="addcontract">
        <section v-if="is_check && $store.getters['contracts/getAllContracts'].length>0" class="mb-5">
            <header class="text-xs-center white--text">
                <h2>Den zu überprüfenden Vertrag wählen</h2>
                <p>Wählen Sie aus der folgenden Liste einen Ihrer Bestandsverträge für den Tarifcheck aus.</p>
            </header>
            <ContractList topath="tariffcheck" gridclass="md6" />
        </section>
        <header v-if="is_check" class="text-xs-center white--text">
            <h3>{{ is_check ? `... oder Neuen Vertrag für Tarifcheck hinzufügen` : `Versicherungstyp wählen` }}</h3>
            <p>Wählen Sie bitte den Versicherungsbereich von Ihrem Vertrag aus.</p>
        </header>
        <header v-else class="text-xs-center white--text">
            <h2>Verträge zu meiner VAPP hinzufügen</h2>
            <p>Wählen Sie bitte eine Variante aus, wie Sie Ihre Versicherungsverträge hinzufügen möchten. Ihre Vertragsdetails und Dokumente werden zukünftig automatisch mit dem Versicherer aktualisiert. Im <router-link to="/mandate" title="Maklermandat-Seite aufrufen">Maklermandat <v-icon>open_in_new</v-icon></router-link> können Sie jederzeit die Berechtigung dafür erteilen und zurücknehmen.</p>
        </header>

        <v-layout row wrap class="mt-4">
            <v-flex class="xs12 md6 lg4 offset-lg2 px-2 mt-3">
                <v-card light hover :to="selfServiceLink">
                    <div class="pa-3 text-xs-center">
                        <v-avatar size="7rem"><v-icon class="icon">touch_app</v-icon></v-avatar>
                        <div class="headline mb-2">Selbst hinzufügen</div>
                        <div>
                            <p>Sie geben Vertragsart, Versicherer und Vertragsnummer an, wir machen den Rest.</p>
                        </div>
                    </div>
                </v-card>
            </v-flex>
            <v-flex class="xs12 md6 lg4 px-2 mt-3">
                <v-card light hover @click="$refs.docUploadInput.click()">
                    <div class="pa-3 text-xs-center">
                        <v-avatar size="7rem"><v-icon class="icon">add_a_photo</v-icon></v-avatar>
                        <div class="headline mb-2">Foto hochladen</div>
                        <div>
                            <p>Foto oder Dokument vom Vertrag hochladen und VAPP arbeiten lassen.</p>
                        </div>
                    </div>
                    <v-progress-linear v-if="message.progress" :value="message.progress" height="5" color="black"></v-progress-linear>
                </v-card>
            </v-flex>
        </v-layout>

        <input type="file" ref="docUploadInput" @change="onFileChanged" accept="application/pdf, image/*" multiple hidden />
    </div>
</template>

<script>
import ContractList from '@/components/ContractList'

export default {
    data: () => ({
        contract: {
            product: { 
                icon: 'find_in_page', 
                name: 'Vertrag wird erstellt...' 
            },
            productpartner: {
                name: '?'
            },
            kind: 'Vertrag wird erstellt...'
        },
        message: {
            progress:0
        }
    }),

    computed: {
        is_check(){
            return this.$route.name=='addtariffcheck'
        },
        selfServiceLink(){
            return this.$route.path + (this.$route.path.endsWith('/') ? 'chosetype' : '/chosetype')
        }
    },

    components: {
        ContractList
    },

    methods: {
        onFileChanged (event) {
            Array.from(event.target.files).forEach(file => {
                //console.log(file);
                if(file.type.search("image")<0 && file.type != "application/pdf"){
                    this.$snotify.warning('Der Dateityp wird zZt. nicht unterstützt!', 'Warning');
                    return false;
                }
                this.addMessage(file);
                return true
            });
        },

        addMessage(file){
            if(file){
                this.$snotify.simple('Wird hochgeladen ...');
                this.$store.dispatch('contracts/addContract', { ...this.contract, ...{is_mandate:1} }).then(newContract => {
                    // let file_type = (file.type.search("image")<0) ? 'pdf' : 'image';
                    if(this.is_check){
                        this.$store.dispatch('contracts/setTarifcheck2Contract', newContract);
                    }
                    this.message = {
                        contract_id: newContract.id,
                        sender: 'user',
                        type: 'contract',
                        progress:0,
                        name: 'Foto/ Scan vom Vertrag'
                    };
                    this.$store.dispatch('chat/addUserChatMessage', this.message);
                    this.$store.dispatch('files/uploadFile', {
                        uploadfile: file, 
                        fileobject: this.message
                    }).then(fileobj => {
                        this.$store.dispatch('chat/setTodo', {
                            type: `NEW_CONTRACT`,
                            subject: this.is_check ? `Neuer Tarifcheck angefordert mit Fotoupload des zu prüfenden Vertrages` : `Neuer FOTO-${newContract.status} angelegt von ${this.$store.getters['user/getDisplayName'](false)}`,
                            content: `${this.$store.getters['user/getDisplayName'](true)} hat durch das Hochladen eines Bildes/ Dokuments ein ${newContract.status} neu angelegt. Bitte überprüfen Sie den ${newContract.status} entsprechend der im hochgeladenen Bild/ Dokument zu erkennenden Daten und vervollständigen/ übertragen Sie diese im Vertrag. Maklervertrag an Versicherer senden. ${this.is_check ? 'TARIFCHECK ausführen!' : ''}`,
                            cid: newContract.id
                        });
                        this.$snotify.success('Vertrag wurde erfolgreich hinzugefügt');
                        this.$router.push({ path: `/contract/${newContract.id}` });
                    });
                });
            }
        }
    }
}
</script>


<style scoped>
    .icon{
        font-size:7rem;
    }
    .opa50{
        cursor: not-allowed;
    }
    .v-progress-linear{
        margin: 0;
    }
</style>